import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import { store } from './store/index'
// import './registerServiceWorker'
import VueResource from 'vue-resource'
import VueNativeSock from 'vue-native-websocket'
import Notifications from 'vue-notification'
import VueI18n from 'vue-i18n'
import VueApexCharts from 'vue-apexcharts'
import { zh } from './locale/zh'
import { en } from './locale/en'

import './styles/common.scss'
import './styles/components/tables.scss'
import './plugins/date-range-picker'
import './filters/date-filter'

Vue.use(VueResource)
Vue.use(VueI18n)
Vue.use(VueApexCharts)

var i18n = new VueI18n({
  locale: 'en',
  messages: {
    en: en,
    zh: zh,
  },
})

function getUrl() {
  const isHTPPS = location.protocol === 'https:'
  const prefix = isHTPPS ? 'wss://' : 'ws://'
  const defaultHost = location.hostname

  const suffix = !isHTPPS
    ? `${process.env.VUE_APP_ASR_DEV_ROUTE || defaultHost}:${process.env.VUE_APP_ASR_DEV_PORT}`
    : `${process.env.VUE_APP_ASR_DOMAIN || defaultHost}/${process.env.VUE_APP_ASR_WS_ROUTE}`

  return `${prefix}${suffix}/WEBService/ServiceServer2`
}

Vue.use(Notifications)

Vue.use(VueNativeSock, getUrl(), {
  // /client/ws/status
  format: 'S16LE',
  connectManually: true,
})

Vue.config.productionTip = false

Vue.http.options.xhr = {
  withCredentials: true,
}
Vue.http.options.emulateJSON = true

Vue.component('apexchart', VueApexCharts)

Vue.config.errorHandler = function (err, vm, info) {
  console.log(err)
  console.log(vm)
  console.log(info)
}

/***** TODO *****/
/***** Need to maintain sign in state *****/

new Vue({
  i18n: i18n,
  router,
  store,
  render: (h) => h(App),
  created() {},
}).$mount('#app')
